import { cva, type VariantProps } from "class-variance-authority";
import clsx from "clsx";

/** Props Interface */
export interface DividerProps extends VariantProps<typeof divider> {
	className?: string;
}

export const Divider: React.FC<DividerProps> = ({ variant, className }) => {
	/** Variants */
	const classes = divider({ variant });

	/** Render */
	return (
		<hr
			tabIndex={-1}
			className={clsx(classes, className)}
		/>
	);
};

const divider = cva([""], {
	variants: {
		variant: {
			default: [],
			card: ["card-divider last:hidden"],
			"data-grid-divider": ["card-divider col-span-2"],
			"content-card": ["-mx-4"],
			modal: ["modal-divider"],
			listbox: ["-mx-1"],
		},
	},
	defaultVariants: {
		variant: "default",
	},
});
